export default __webpack_public_path__ + "static/media/button__multi-users.a95b3c39.svg";